module.exports = __webpack_public_path__ + "cancel-black2.png?c44b7c19ef3b7e18258fb2c790e724a4";